export default defineNuxtPlugin(() => {
    const currencyCode = (value) => {
        if (!value) return '';

        if (value === 'GBP') return '£';
        if (value === 'USD') return '$';
        if (value === 'EUR') return '€';

        return value;
    };

    return {
        provide: {
            currencyCode
        }
    };
});
